import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, Input, Modal, Select } from 'v3/components';
import { useFleetManagement } from '../../../shared';
import {
  fetchCustomers,
  fetchOnlyCities
} from 'utils/fetches';

export default function AdvancedFilterModal({ show, onClose }) {

  const {
    setSuggestionAdvancedFilters,
    tempSuggestionAdvancedFilters,
    setTempSuggestionAdvancedFilters,
    loading } = useFleetManagement();

  const handleClose = () => {
    setTempSuggestionAdvancedFilters({});
    setSuggestionAdvancedFilters({});
    onClose();
  };

  const handleConfirm = () => {
    setSuggestionAdvancedFilters({
      originId: tempSuggestionAdvancedFilters?.originCity?.id,
      originProvince: tempSuggestionAdvancedFilters?.originCity?.name,
      originCity: tempSuggestionAdvancedFilters?.originCity?.province?.uf,
      destinationId: tempSuggestionAdvancedFilters?.destinationCity?.id,
      destinationProvince: tempSuggestionAdvancedFilters?.destinationCity?.name,
      destinationCity: tempSuggestionAdvancedFilters?.destinationCity?.province?.uf,
      clientTakerId: tempSuggestionAdvancedFilters?.clientTaker?.map(item => item.id) || [],
      loadNumber: tempSuggestionAdvancedFilters?.loadNumber || null
    });
    onClose();
  };

  return (
    <Modal
      show={show}
      handleClose={handleClose}
      heading="Filtro avançado"
      body={
        <Row>
          <Col md={6} xs={6} className="mb-2">
            <Input
              label="Número da carga"
              type="number"
              value={tempSuggestionAdvancedFilters?.loadNumber}
              onKeyDown={evt =>
                ['e', 'E', '+', '-', '.'].includes(evt.key) &&
                evt.preventDefault()
              }
              onChange={event => {
                setTempSuggestionAdvancedFilters(old => ({
                  ...old,
                  loadNumber: event.target.value
                }));
              }}
            />
          </Col>

          <Col md={6} xs={6}>
            <Select.Async
              label="Cliente Tomador CPF/CNPJ"
              multiple
              onSearch={search => fetchCustomers({ search })}
              value={tempSuggestionAdvancedFilters.clientTaker}
              onChange={value => {
                setTempSuggestionAdvancedFilters(old => ({
                  ...old,
                  clientTaker: value
                }));
              }}
              getOptionLabel={option => `${option?.social_name} - ${option?.cgccpf}`}
              getOptionValue={option => option.id}
            />
          </Col>

          <Col md={6} xs={6}>
            <Select.Async
              label="Origem"
              onSearch={fetchOnlyCities}
              value={tempSuggestionAdvancedFilters?.originCity}
              horizontal
              onChange={value => setTempSuggestionAdvancedFilters(old => ({
                ...old,
                originCity: value
              }))}
              getOptionLabel={option =>
                `${`${option.name} - ${option.province?.uf}`}`
              }
              getOptionValue={option =>
                `${`${option.name}-${option.province?.uf}`}`
              }
            />
          </Col>

          <Col md={6} xs={6}>
            <Select.Async
              label="Destino"
              onSearch={fetchOnlyCities}
              value={tempSuggestionAdvancedFilters?.destinationCity}
              horizontal
              onChange={value => setTempSuggestionAdvancedFilters(old => ({
                ...old,
                destinationCity: value
              }))}
              getOptionLabel={option =>
                `${`${option.name} - ${option.province?.uf}`}`
              }
              getOptionValue={option =>
                `${`${option.name}-${option.province?.uf}`}`
              }
            />
          </Col>
        </Row>
      }
      footer={
        <Row>
          <Col style={{ gap: 8 }} className="d-flex justify-content-end">
            <Button loading={loading} onClick={onClose} variant="secondary">
              Cancelar
            </Button>
            <Button loading={loading} onClick={handleConfirm} className="ms-2">
              Aplicar
            </Button>
          </Col>
        </Row>
      }
    />
  );
}
